import { useCallback } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useCartContents } from '@zenbusiness/application-commons-ecommerce';
import { useIntl } from '@zenbusiness/application-commons-intl';

import cartMapper from '#client/utils/clickstream/cartMapper';

export default function useCheckoutStepCompleted() {
  const trackCheckoutStepCompleted = useClickstreamCallback('checkoutStepCompleted');
  const { items: cartItems, totalPrice, totalServiceAmount } = useCartContents();
  const { formatMessage } = useIntl();
  return useCallback(
    ({ step, stepName }) => {
      const cartData = cartMapper({
        cartItems,
        totalPrice,
        totalServiceAmount,
        formatMessage
      });
      trackCheckoutStepCompleted({ ...cartData, step, stepName });
    },
    [cartItems, totalPrice, totalServiceAmount, trackCheckoutStepCompleted, formatMessage]
  );
}
